import React from 'react'
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import { browserHistory } from 'react-router';
import moment from 'moment'

import NavLink from '../Routes/NavLink'

import { leases } from '../../core/controllers/Leases'
import { multiTaskerManager } from '../../core/controllers/MultiTaskerManager'

export default class LeaseList extends React.Component {
    constructor(props) {
        super(props);

        this.index = 0;
    }

    componentDidMount() {
        this.setupToolTips();
    }

    openMultiTasker(e) {
        e.preventDefault();
        multiTaskerManager.setData(this.building_id, 'showAssociatedBuilding');
        multiTaskerManager.forceUpdate();
        return false
    }

    /**
     * Formats money, if not value, return 0
     * @param {*} e
     */
    formatAmount(value) {
        // format money
        var money = parseInt(value);
        money = money / 100;
        money = Number(money.toFixed(2)).toLocaleString();
        if(money == 'NaN') { money = 0; }

        return money;
    }

    formatIndexColumn(cell, row) {
        ++this.index;
        return this.index;
    }

    formatMoney(cell, row) {
        return '$' + this.formatAmount(cell);
    }

    formatActionOptions(cell, row) {
        if(row.tenant_firstname === undefined) {
            return
        } else {
            return (
                <span>
                { row.pending != undefined && row.pending == 1 && (
                    <span class="important-small-blue">Awaiting E-Sig</span>
                )}
                </span>
            )
        }
    }

    formatDate(cell, row) {
        if(cell) {
            return moment(cell).format('D MMM YYYY');
        } else {
            return 'Not Set';
        }
    }

    setupToolTips() {
        setTimeout(() => {
            jQuery(".tooltip_custom").hover(function() {
				jQuery(this).find('[data-toggle="tooltip"]').tooltip('show');
			}, function() {
				jQuery(this).find('[data-toggle="tooltip"]').tooltip('hide');
			}
		    );
        }, 500);
	}

    flattenObject(ob, tenantNames, propertyData) {
        var toReturn = {};
        for (var i in ob) {
            if (!ob.hasOwnProperty(i)) continue;
            if ((typeof ob[i]) == 'object') {
                var flatObject = this.flattenObject(ob[i]);
                for (var x in flatObject) {
                    if (!flatObject.hasOwnProperty(x)) continue;
                    toReturn[x] = flatObject[x];
                }
            } else {
                toReturn[i] = ob[i];
            }
        }
        toReturn["tenants_names"] = tenantNames;
        toReturn["property_data"] = propertyData;
        return toReturn;
    }

    formatBuildingLink(cell, row) {
        if(cell !== null && cell !== undefined) {
            return <a href="#" onClick={this.openMultiTasker.bind(row)}>{cell}</a>
        } else {
            return 'None';
        }
    }

    formatBuildingGroup(cell, row) {
        if(cell !== null && cell !== undefined) {
            return cell
        } else {
            return 'None';
        }
    }

    formatSpaceType(cell, row) {
        if(cell !== null && cell !== undefined) {
            return <span>{row.contract_bedroom_type},{row.contract_bathroom_type}</span>
        } else {
            return 'Not Set';
        }
    }

    formatSqft(cell, row) {
        if(cell !== null && cell !== undefined) {
            return <span>{row.sqft} Sqft</span>
        } else {
            return 'Not Set';
        }
    }

    didSelectRow(row) {
        browserHistory.push('/lease/' + row.contract_id);
    }

    stopSelectRow(e) {
        e.stopPropagation();
    }

    formatProperty(cell, row) {
        if(row.property_data != undefined) {
            var shortenedPropertyName = row.property_data.property_name;
            if (row.property_data.property_name.length > 15) {
                shortenedPropertyName = row.property_data.property_name.substring(0, 15) + "..."
            }
            return (
            <span onClick={this}>
                <NavLink to={"/properties/" + row.property_data.property_id}>{shortenedPropertyName}</NavLink>
            </span>
            )
        } else {
            return '';
        }
    }

    render(){
        var self = this;
        const leaseData = this.props.leaseData;
        const formattedLeaseData = leaseData != null ? leaseData.map(function(lease) {
            var leaseData = {
                id: lease.belongTo.contract_id,
                contract_id: lease.belongTo.contract_id,
                contract_amount: lease.data.contract_amount,
                security_deposit: lease.data.security_deposit,
                effective_date: lease.data.effective_date,
                contract_expiration_date: lease.data.contract_expiration_date,
                created_date: lease.data.created_date,
                title: lease.data.title
            }
            if (lease.meta_data.length > 0) {
                var tenantName = "";
                lease.meta_data.map(function(tenant) {
                    if (tenantName == "") {
                        tenantName += tenant.tenant_firstname;
                    } else {
                        tenantName += ", " + tenant.tenant_firstname;
                    }
                });
                leaseData["tenants_names"] = tenantName;
                leaseData['tenant_firstname'] = tenantName;
            }
            var isPending = 0;
            if (lease.agreement != null && lease.agreement.length > 0) {
                lease.agreement.map(function(agreement) {
                    if (agreement.pending == "1") {
                        isPending = 1;
                    }
                });
            }
            leaseData["pending"] = isPending;
            if (lease.property != null) {
                var propertyData = {}
                propertyData["property_id"] = lease.property.property_id
                propertyData["property_name"] = lease.property.property_name
            }
            leaseData["property_data"] = propertyData;

            return leaseData;
        }): [];
        const options = {
            onRowClick: this.didSelectRow,
            sizePerPage: 25
        };

        return (
            <div class="content">
                {window.innerWidth < 992 ? (
                    <BootstrapTable data={formattedLeaseData} version='4' striped search pagination hover options={options}>
                        <TableHeaderColumn dataField='id' width="50" dataFormat={this.formatIndexColumn} hidden={window.matchMedia('(max-width: 992px)').matches} isKey={ true }></TableHeaderColumn>
                        <TableHeaderColumn dataField='title' dataSort={ true }>Title</TableHeaderColumn>
                        <TableHeaderColumn dataField='property_data' dataFormat={this.formatProperty.bind(this.stopSelectRow)} dataSort={ true }>Property</TableHeaderColumn>
                        <TableHeaderColumn dataField='tenants_names' dataSort={ true }>Tenant</TableHeaderColumn>
                    </BootstrapTable>
                ) : (
                    <BootstrapTable data={formattedLeaseData} version='4' striped search pagination hover options={options}>
                        <TableHeaderColumn dataField='id' width="50" dataFormat={this.formatIndexColumn} hidden={window.matchMedia('(max-width: 992px)').matches} isKey={ true }></TableHeaderColumn>
                        <TableHeaderColumn dataField='title' dataSort={ true }>Title</TableHeaderColumn>
                        <TableHeaderColumn dataField='property_data' dataFormat={this.formatProperty.bind(this.stopSelectRow)} dataSort={ true }>Property</TableHeaderColumn>
                        <TableHeaderColumn dataField='tenants_names' dataSort={ true }>Tenant</TableHeaderColumn>
                        <TableHeaderColumn dataField='contract_amount' dataFormat={this.formatMoney.bind(this)} dataSort={ true }>Amount</TableHeaderColumn>
                        <TableHeaderColumn dataField='security_deposit' dataFormat={this.formatMoney.bind(this)} dataSort={ true }>Deposit</TableHeaderColumn>
                        <TableHeaderColumn dataField='effective_date' dataFormat={this.formatDate} dataSort={ true }>Move-in</TableHeaderColumn>
                        <TableHeaderColumn dataField='contract_expiration_date' dataFormat={this.formatDate} dataSort={ true }>Renewal</TableHeaderColumn>
                        <TableHeaderColumn dataField='created_date' dataFormat={this.formatDate} dataSort={ true }>Created</TableHeaderColumn>
                        <TableHeaderColumn dataAlign='center' dataFormat={this.formatActionOptions.bind(this)}></TableHeaderColumn>
                    </BootstrapTable>
                )}
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/components/Leases/LeaseList.jsx